import { css } from '@emotion/core';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const isNumber = (value) => typeof value === 'number';
const Styles = labelStyles('Grid', {
    root: (props) => css({
        display: 'grid',
        alignItems: props.alignItems,
        gap: props.gap,
        gridTemplateColumns: isNumber(props.columns)
            ? `repeat(${props.columns}, 1fr)`
            : props.columns,
    }),
});
export const Grid = (props) => {
    return isolateComponent("div", { css: Styles.root(props) }, props.children);
};
//# sourceMappingURL=Grid.js.map
// @zapier/design-system@5.18.1 (f78072c92)
